module.exports = __webpack_public_path__ + "img/savings.3ba3a99d.png";